import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSavings = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 6.267C14.5 6.726 14.317 7.167 13.992 7.492C13.667 7.817 13.226 8 12.767 8",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.844 5.4H8.578",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.715 7.564C4.657 7.564 4.602 7.541 4.562 7.5C4.521 7.46 4.498 7.405 4.498 7.347C4.498 7.29 4.521 7.235 4.562 7.194C4.602 7.153 4.657 7.13 4.715 7.13",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.715 7.564C4.772 7.564 4.827 7.541 4.868 7.5C4.909 7.46 4.932 7.405 4.932 7.347C4.932 7.29 4.909 7.235 4.868 7.194C4.827 7.153 4.772 7.13 4.715 7.13",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.631 3.597C4.955 2.372 3.233 2.367 3.233 2.367L3.597 4.897C3.121 5.411 2.769 6.028 2.569 6.7H1.5V10.167H2.939C3.236 10.691 3.628 11.155 4.094 11.536V13.2C4.096 13.315 4.142 13.424 4.223 13.505C4.304 13.586 4.413 13.632 4.528 13.633H5.4C5.514 13.632 5.624 13.586 5.705 13.505C5.786 13.424 5.832 13.315 5.833 13.2V12.484C6.959 12.857 8.175 12.857 9.3 12.484V13.2C9.302 13.315 9.348 13.424 9.429 13.505C9.51 13.586 9.619 13.632 9.733 13.633H10.6C10.715 13.632 10.824 13.586 10.905 13.505C10.986 13.424 11.032 13.315 11.033 13.2V11.548C11.568 11.123 12.001 10.584 12.301 9.97C12.601 9.356 12.76 8.683 12.767 8C12.767 4.25 8.693 2.575 5.631 3.597Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSavings;
